import * as config_json from './config.json';

export const config = config_json;
